<div class="col-lg-12 field-style list-cl">
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <p-table
          [value]="taskList"
          #dt
          stripedRows
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 265px)"
          [size]="'small'"
          [resizableColumns]="true"
          responsiveLayout="scroll"
          (onRowReorder)="sortRow($event)"
          styleClass="p-datatable-customers ordersListing search-more"
          [rowHover]="true"
          [rows]="defaultTake"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
          [paginator]="true"
          [filterDelay]="0"
          selectionMode="single"
          sortMode="multiple"
          [lazy]="true"
          [totalRecords]="totalRecords"
          (onLazyLoad)="getAllTaskList($event)"
          [globalFilterFields]="tableGlobalFilters"
          [reorderableColumns]="true"
          styleClass="table-listing no-border">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th *ngIf="bulkArchive && !archivedTasks"></th>
              <th></th>
              <th>Type</th>
              <th pSortableColumn="client">
                Client
                <p-sortIcon></p-sortIcon>
              </th>
              <th>Job Name</th>
              <th>Buyer Name</th>
              <th>Nickname</th>
              <th *ngIf="taskType.toString() !== '1'">Supplier</th>
              <th>Task</th>
              <!-- <th>Description</th> -->
              <th>Due Date</th>
              <th>Priority</th>
              <th>Status</th>
              <th *ngIf="taskType.toString() !== '1'">ESD</th>
              <th>IHD</th>
              <th *ngIf="taskType.toString() !== '1'">PO</th>
              <th>Assigned To</th>
              <th pSortableColumn="owner" class="width-50">
                BC
                <p-sortIcon></p-sortIcon>
              </th>
              <!--<th>Note</th>-->
            </tr>
            <tr>
              <th *ngIf="bulkArchive && !archivedTasks"></th>
              <th></th>
              <th></th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="client"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="jobName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="buyer"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="nickName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th *ngIf="taskType.toString() !== '1'">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="supplier"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="title"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="duedate"
                    appendTo="body"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                    <ng-template
                      field="duedate"
                      appendTo="body"
                      pTemplate="filter"
                      let-value
                      let-filter="filterCallback">
                      <p-datePicker
                        appendTo="body"
                        class="only-icon"
                        (onSelect)="
                          populateFilterFromDropDown($event, 'duedate', true)
                        "
                        [showIcon]="true"
                        [selectOtherMonths]="true"
                        placeholder="Select Date">
                      </p-datePicker>
                    </ng-template>
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex drop-wdth">
                  <p-columnFilter field="priorityType" [showMenu]="false">
                    <ng-template
                      field="priorityType"
                      pTemplate="filter"
                      let-value
                      let-filter="filterCallback">
                      <p-select
                        appendTo="body"
                        [options]="priorityTypeList"
                        (onChange)="
                          populateFilterFromDropDown($event, 'priorityType')
                        "
                        placeholder="Select">
                        <ng-template let-option pTemplate="item">
                          <span>{{ option }}</span>
                        </ng-template>
                      </p-select>
                    </ng-template>
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex drop-wdth">
                  <p-columnFilter field="status" [showMenu]="false">
                    <ng-template
                      field="status"
                      pTemplate="filter"
                      let-value
                      let-filter="filterCallback">
                      <p-select
                        appendTo="body"
                        [options]="stateList"
                        optionLabel="name"
                        optionValue="name"
                        (onChange)="
                          populateFilterFromDropDown($event, 'status')
                        "
                        placeholder="Select">
                        <ng-template let-option pTemplate="item">
                          <span>{{ option.name }}</span>
                        </ng-template>
                      </p-select>
                    </ng-template>
                  </p-columnFilter>
                </div>
              </th>
              <th *ngIf="taskType.toString() !== '1'">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="esd"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                    <ng-template
                      field="esd"
                      pTemplate="filter"
                      let-value
                      let-filter="filterCallback">
                      <p-datePicker
                        appendTo="body"
                        (onSelect)="
                          populateFilterFromDropDown($event, 'esd', true)
                        "
                        [showIcon]="true"
                        [selectOtherMonths]="true"
                        class="only-icon">
                      </p-datePicker>
                    </ng-template>
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="ihd"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                    <ng-template
                      field="ihd"
                      pTemplate="filter"
                      let-value
                      let-filter="filterCallback">
                      <p-datePicker
                        appendTo="body"
                        class="only-icon"
                        (onSelect)="
                          populateFilterFromDropDown($event, 'ihd', true)
                        "
                        [showIcon]="true"
                        [selectOtherMonths]="true"
                        placeholder="Select Date">
                      </p-datePicker>
                    </ng-template>
                  </p-columnFilter>
                </div>
              </th>
              <th *ngIf="taskType.toString() !== '1'">
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="poNumber"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex assign-grid">
                  <p-columnFilter field="assignedto" [showMenu]="false">
                    <ng-template
                      field="assignedto"
                      pTemplate="filter"
                      let-value
                      let-filter="filterCallback">
                      <p-select
                        appendTo="body"
                        [options]="allAssignedUserList"
                        optionLabel="name"
                        optionValue="personalNumber"
                        [showClear]="true"
                        (onChange)="
                          populateFilterFromDropDown($event, 'assignedto')
                        "
                        placeholder="Select">
                        <ng-template let-option pTemplate="item">
                          <span>{{ option.name }}</span>
                        </ng-template>
                      </p-select>
                    </ng-template>
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <!-- OSCustom -->
                <div class="d-flex assign-grid">
                  <p-columnFilter field="owner" [showMenu]="false">
                    <ng-template
                      field="owner"
                      pTemplate="filter"
                      let-value
                      let-filter="filterCallback">
                      <p-select
                        appendTo="body"
                        [showClear]="true"
                        [options]="assignedProjectOwnersList"
                        (onChange)="populateFilterFromDropDown($event, 'owner')"
                        placeholder="Select">
                        <ng-template let-option pTemplate="item">
                          <span>{{ option }}</span>
                        </ng-template>
                      </p-select>
                    </ng-template>
                  </p-columnFilter>
                </div>

                <!-- <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="owner"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div> -->
              </th>
              <!--<th>
    <div class="d-flex">
      <p-columnFilter type="text"
                      field="note"
                      (input)="onFilterInput($event)"
                      [showMenu]="false">
      </p-columnFilter>
    </div>
  </th>-->
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-task let-rowIndex="rowIndex">
            <tr
              [pReorderableRow]="rowIndex"
              class="p-selectable-row"
              [pSelectableRow]="task"
              [pSelectableRowIndex]="rowIndex"
              [ngClass]="{
                'disabled-tr': task.isExternal && !task.isAdmin,
                'date-red': !task.isExternal && task.dueDatePassed,
              }">
              <td *ngIf="bulkArchive && !archivedTasks">
                <p-checkbox
                  [(ngModel)]="task.archiveSelected"
                  [binary]="true"
                  (onChange)="onRowToggle($event, task)"></p-checkbox>
              </td>
              <td class="drap-ico">
                <span
                  pReorderableRowHandle
                  class="pi pi-bars"
                  [class.disabled]="task.isExternal && !task.isAdmin">
                </span>
              </td>
              <td (click)="redirectToTaskSummary(task.taskId)" class="blur-bar">
                <span
                  class="link line-number underline blurshade cursor-pointer">
                  {{ getTaskTypeTitle(task.taskType) }}
                </span>
              </td>
              <td
                class="blur-bar task-title-cell"
                pEditableColumn
                [pEditableColumnDisabled]="
                  !(task.taskType === 1 && !task.projectWorkflowId)
                ">
                <p-cellEditor>
                  <ng-template
                    pTemplate="input"
                    *ngIf="task.taskType === 1 && !task.projectWorkflowId">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="task.customerNameWithNoProject"
                      (keydown.enter)="
                        onTaskFieldEdit(task, 'customerNameWithNoProject')
                      "
                      (keydown.arrowLeft)="$event.stopPropagation()"
                      (keydown.arrowRight)="$event.stopPropagation()"
                      (focus)="
                        onClientNameWithoutProjectFocus(
                          task.customerNameWithNoProject
                        )
                      "
                      (focusout)="
                        onTaskFieldEdit(task, 'customerNameWithNoProject')
                      " />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div
                      [pTooltip]="
                        task.projectWorkflowId === null && task.taskType === 1
                          ? task.customerNameWithNoProject
                          : task.clientName
                      "
                      tooltipPosition="top"
                      class="blurshade d-flex justify-content-between align-items-center">
                      <span class="task-title-multiline">{{
                        task.projectWorkflowId === null && task.taskType === 1
                          ? task.customerNameWithNoProject
                          : task.clientName
                      }}</span>
                    </div>
                  </ng-template>
                </p-cellEditor>

                <!-- <div
                  [pTooltip]="task.clientName"
                  tooltipPosition="top"
                  tooltipStyleClass="tasktooltip"
                  class="blurshade d-flex justify-content-between align-items-center">
                  <span class="blurshade task-title-multiline">{{
                    task.projectWorkflowId === null && task.taskType === 1
                      ? task.customerNameWithNoProject
                      : task.clientName
                  }}</span>
                </div> -->
              </td>
              <td
                [pTooltip]="task.jobName"
                tooltipPosition="top"
                class="blur-bar jobFixWidth task-title-cell"
                [ngClass]="{
                  jobFixWidth: !isBarCollapse,
                  jobAutoWidth: isBarCollapse,
                }"
                (click)="
                  openWorkflowModal(task.projectWorkflowId, task.salesOrderId)
                ">
                <div
                  class="task-title-multiline"
                  [innerHTML]="task.jobName"></div>
              </td>
              <td class="blur-bar" pEditableColumn>
                <!-- <div class="blurshade" [innerHTML]="addLineBreakAfterThreeWords(task.buyerName)"></div> -->

                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <div>
                      <div class="form-group has-float-label">
                        <input
                          pInputText
                          *ngIf="task.taskType === 1 && !task.client"
                          type="text"
                          [(ngModel)]="task.buyerName"
                          (keydown.enter)="onTaskFieldEdit(task, 'buyerName')"
                          (keydown.arrowLeft)="$event.stopPropagation()"
                          (keydown.arrowRight)="$event.stopPropagation()"
                          (focusout)="onTaskFieldEdit(task, 'buyerName')"
                          (focus)="
                            onBuyerNameWithoutProjectFocus(task.buyerName)
                          " />

                        <input
                          jniAutoCompleteBlocker
                          *ngIf="task.taskType !== 1 || task.client"
                          #mydropBuyer
                          [value]="selectedBuyer"
                          type="text"
                          class="form-control"
                          (input)="
                            getBuyer($event, buyerPopoverListView, task.client)
                          "
                          (keyup)="
                            onBuyerSearchOpenToggle(
                              buyerPopoverListView,
                              $event,
                              mydropBuyer
                            )
                          "
                          (keydown.Tab)="
                            getBuyer($event, buyerPopoverListView, task.client)
                          "
                          (click)="
                            getBuyer($event, buyerPopoverListView, task.client)
                          " />
                      </div>
                      <p-popover
                        class="order-dropdown add dropDownPosition search-table-position"
                        #buyerPopoverListView
                        aria-labelledby="dropdownBasic1">
                        <p-table
                          #dt
                          [value]="buyerLists"
                          styleClass="p-datatable-customers order-listing"
                          [rowHover]="true"
                          [rows]="10"
                          [showCurrentPageReport]="true"
                          [rowsPerPageOptions]="[10, 25, 50]"
                          [paginator]="false"
                          [filterDelay]="0">
                          <ng-template pTemplate="header">
                            <tr>
                              <th class="name">Buyer</th>
                              <th class="client" pSortableColumn="client">
                                Client
                                <p-sortIcon field="Client"></p-sortIcon>
                              </th>
                              <th class="vaccount">Account</th>
                              <th class="street">Street</th>
                              <th class="city">City</th>
                              <th class="state">State</th>
                              <th class="lastOrderDate">Last order date</th>
                            </tr>
                            <tr>
                              <th></th>
                              <th>
                                <div class="d-flex">
                                  <input
                                    jniAutoCompleteBlocker
                                    pInputText
                                    type="text"
                                    name="organizationNameD365"
                                    id="organizationNameD365"
                                    style="max-width: 200px"
                                    (input)="
                                      dt.filter(
                                        $any($event.target).value,
                                        'organizationNameD365',
                                        'contains'
                                      )
                                    "
                                    placeholder=""
                                    class="p-column-filter p-inputtext p-component" />
                                </div>
                              </th>
                              <th></th>
                              <th></th>
                              <th></th>
                              <th></th>
                              <th></th>
                            </tr>
                          </ng-template>
                          <ng-template
                            pTemplate="body"
                            let-buyerList
                            let-rowIndex="rowIndex">
                            <tr
                              class="p-selectable-row mousepointer"
                              (click)="
                                onBuyerSelection(
                                  buyerList,
                                  buyerPopoverListView,
                                  task
                                )
                              ">
                              <td class="buyer mousepointer">
                                {{ buyerList.buyer }}
                              </td>
                              <td class="client mousepointer">
                                {{ buyerList.organizationNameD365 }}
                              </td>
                              <td class="vaccount mousepointer">
                                {{ buyerList.account }}
                              </td>
                              <td
                                style="width: 200px"
                                class="sname mousepointer">
                                {{ buyerList.street }}
                              </td>
                              <td class="city mousepointer">
                                {{ buyerList.city }}
                              </td>
                              <td
                                style="width: 72px"
                                class="state mousepointer">
                                {{ buyerList.state }}
                              </td>
                              <td
                                style="width: 75px"
                                class="country mousepointer">
                                {{ buyerList.lastOrder | date: "yyyy-MM-dd" }}
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="20" *ngIf="showSmallLoader">
                                <div
                                  class="lds-ring inline me-auto ms-2"
                                  *ngIf="showSmallLoader">
                                  <jni-spinner></jni-spinner>
                                </div>
                                <span *ngIf="!showSmallLoader"
                                  >No buyer found.</span
                                >
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </p-popover>
                    </div>
                    <!-- <input pInputText
        type="text"
        [(ngModel)]="task.buyerName"
        (keydown.enter)="onTaskFieldEdit(task, 'buyer')" /> -->
                  </ng-template>

                  <ng-template pTemplate="output">
                    <div
                      class="blurshade d-flex justify-content-between align-items-center">
                      <span
                        class="blurshade task-title-multiline"
                        [pTooltip]="task.buyerName"
                        tooltipPosition="top"
                        [innerHTML]="limitString(task.buyerName, 30)"></span>
                    </div>
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="blur-bar task-title-cell" pEditableColumn>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="task.nickName"
                      (keydown.enter)="onTaskFieldEdit(task, 'nickName')"
                      (keydown.arrowLeft)="$event.stopPropagation()"
                      (keydown.arrowRight)="$event.stopPropagation()"
                      (focus)="onNicknameFocus(task)"
                      (focusout)="onTaskFieldEdit(task, 'nickName')"
                      (pointerdown)="onTitleMouseDown($event)"
                      (pointerup)="onTitleMouseUp($event)" />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div
                      [pTooltip]="task.nickName"
                      tooltipPosition="top"
                      class="blurshade d-flex justify-content-between align-items-center">
                      <span class="task-title-multiline">{{
                        task.nickName
                      }}</span>
                    </div>
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="blur-bar" *ngIf="taskType.toString() !== '1'">
                <div
                  class="blurshade"
                  [innerHTML]="
                    addLineBreakAfterThreeWords(task.supplierName)
                  "></div>
              </td>
              <td class="blur-bar task-title-cell" pEditableColumn>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="task.title"
                      (keydown.enter)="onTaskFieldEdit(task, 'title')"
                      (keydown.arrowLeft)="$event.stopPropagation()"
                      (keydown.arrowRight)="$event.stopPropagation()"
                      (focus)="onTitleFocus(task)"
                      (focusout)="onTaskFieldEdit(task, 'title')"
                      (pointerdown)="onTitleMouseDown($event)"
                      (pointerup)="onTitleMouseUp($event)" />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div
                      class="blurshade d-flex justify-content-between align-items-center"
                      [pTooltip]="task.title"
                      tooltipPosition="top">
                      <span class="task-title-multiline">{{ task.title }}</span>
                      <span
                        class="infoico-circle cursor-pointer d-flex align-items-center justify-content-center"
                        (click)="redirectToTaskSummary(task.taskId)"
                        ><i class="pi pi-info-circle"></i
                      ></span>
                    </div>
                  </ng-template>
                </p-cellEditor>
              </td>

              <td #dueDateTd class="duedate-cal blur-bar cal-task app-due">
                <div class="duedate-cal cal-leftpos cal-task">
                  <div class="blurshade">
                    {{ formatDate(task.dueDate) }}
                  </div>
                </div>
                <div *ngIf="task.isArchived" class="unarchive-div">
                  <i
                    (click)="archiveEvent(task, false)"
                    class="pi pi-arrow-circle-up"></i>
                </div>
                <p-datePicker
                  *ngIf="!task.isArchived"
                  #calendar
                  class="only-icon"
                  [(ngModel)]="task.calendarDueDate"
                  [showIcon]="true"
                  appendTo="body"
                  [selectOtherMonths]="true"
                  (onSelect)="onTaskFieldEdit(task, 'calendarDueDate')"
                  placeholder="Select Date">
                  <ng-template pTemplate="footer">
                    <span
                      class="link cursor-pointer"
                      (click)="archiveEvent(task, true)"
                      >Mark as archived</span
                    >
                  </ng-template>
                </p-datePicker>
              </td>
              <td
                style="text-align: center"
                class="pro-box-drop blur-bar status-wdth">
                <p-select
                  id="size"
                  [(ngModel)]="task.priorityType"
                  appendTo="body"
                  [options]="priorityList"
                  (onChange)="onPriorityChangeDpdown(task.taskId, $event)"
                  [showClear]="false"
                  (onClick)="$event.stopPropagation()"
                  optionLabel="id"
                  optionValue="id">
                  <ng-template
                    #selectedItem
                    appendTo="body"
                    let-selectedOption
                    class="blurshade">
                    <div
                      [style.backgroundColor]="selectedOption.color"
                      [style.color]="
                        selectedOption.title === 'Standard' ? '#00000' : '#ffff'
                      "
                      class="blurshade drop-textcol">
                      {{ getPriorityTypeTitle(selectedOption.id) }}
                    </div>
                  </ng-template>
                  <ng-template let-element #item class="blurshade">
                    <div
                      [style.backgroundColor]="element.color"
                      class="drop-down-values blurshade drop-textcol"
                      [style.color]="
                        element.title === 'Standard' ? '#00000' : '#ffff'
                      "
                      *ngIf="
                        (task.taskType === 2 && element.production) ||
                        task.taskType === 1
                      ">
                      {{ getPriorityTypeTitle(element.id) }}
                    </div>
                  </ng-template>
                </p-select>
              </td>
              <td class="blur-bar status-wdth">
                <div
                  class="blurshade"
                  *ngIf="!(task.isExternal && !task.isAdmin)">
                  <p-select
                    id="size"
                    [(ngModel)]="task.status"
                    appendTo="body"
                    [options]="
                      task.taskType === 2 ? prodStatusDropDownList : statusList
                    "
                    optionLabel="label"
                    optionValue="value"
                    (onChange)="
                      onStatusDropDownChange(
                        task.taskId,
                        $event.value,
                        task.taskType
                      )
                    "
                    [showClear]="false"
                    (onClick)="$event.stopPropagation()"
                    class="blurshade">
                  </p-select>
                </div>
              </td>
              <td
                #esdTd
                class="blur-bar cal-task app-est"
                *ngIf="taskType.toString() !== '1'">
                <!-- <div class="blurshade">{{ formatDate(task.esd) }}</div> -->
                <div class="blurshade">
                  <div class="duedate-cal cal-leftpos">
                    <div class="blurshade">
                      {{ formatDate(task.esd) }}
                    </div>
                    <p-datePicker
                      #calendar
                      class="only-icon"
                      [(ngModel)]="task.esd"
                      [showIcon]="true"
                      appendTo="body"
                      [selectOtherMonths]="true"
                      *ngIf="
                        task.taskType === 2 && task.projectWorkflowId !== null
                      "
                      (onSelect)="onTaskFieldEdit(task, 'esd')"
                      placeholder="Select Date">
                    </p-datePicker>
                  </div>
                </div>
              </td>
              <td
                #ihdTd
                [ngClass]="getLineIHDClass(task)"
                class="blur-bar cal-task app-ihd">
                <!-- <div class="blurshade">{{ formatDate(task.ihd) }}</div> -->
                <div class="duedate-cal cal-leftpos cal-task">
                  <div class="blurshade">
                    {{ formatDate(task.ihd) }}
                  </div>
                  <p-datePicker
                    #calendar
                    class="only-icon"
                    [(ngModel)]="task.ihd"
                    [showIcon]="true"
                    appendTo="body"
                    [selectOtherMonths]="true"
                    *ngIf="task.projectWorkflowId !== null"
                    (onSelect)="onTaskFieldEdit(task, 'ihd')"
                    placeholder="Select Date">
                  </p-datePicker>
                </div>
              </td>
              <td
                class="blur-bar cursor-pointer"
                *ngIf="taskType.toString() !== '1'">
                <div class="blurshade">
                  <span (click)="redirectOrderSummary(task.salesOrderId)">{{
                    task.poNumber
                  }}</span>
                  <i
                    style="cursor: pointer"
                    (click)="copyText(task.poNumber)"
                    *ngIf="task.poNumber !== ''"
                    class="pi pi-copy"></i>
                </div>
              </td>
              <td
                class="text-center"
                pEditableColumn
                (click)="onEditAssignedTo(task)">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select
                      [(ngModel)]="task.assignedTo"
                      [options]="ownerList"
                      optionLabel="name"
                      optionValue="personalNumber"
                      (onChange)="onEditAssignedToClick(task, task.assignedTo)"
                      [showClear]="false"
                      [filter]="true"
                      appendTo="body"
                      (onClick)="$event.stopPropagation()"
                      class="blurshade">
                    </p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <span
                      class="purple p-2 rounded-circle circle-icon"
                      [style.color]="getTextColor(task.assignedTo)"
                      [style.background]="getColor(task.assignedTo)"
                      *ngIf="task.assignedTo !== ' '"
                      (mouseenter)="
                        showAvatarPopover(
                          $event,
                          task.assignedToUserId,
                          task.assignedTo
                        )
                      "
                      (mouseleave)="hideAvatarPopover()">
                      {{ getAcronym(task.assignedTo) }}
                    </span>
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="blur-bar">
                <div *ngIf="task.owner" class="blurshade text-center">
                  <span
                    class="purple p-2 rounded-circle circle-icon"
                    [style.color]="getTextColor(task.owner)"
                    [style.background]="getColor(task.owner)"
                    *ngIf="task.owner !== ' '"
                    (mouseenter)="
                      showAvatarPopover($event, task.ownerUserId, task.owner)
                    "
                    (mouseleave)="hideAvatarPopover()">
                    {{ getAcronym(task.owner) }}
                  </span>
                </div>
              </td>
              <!--<td class="text-center number blur-bar"
      (click)="openNotesModal(task.taskId, task.notes)">
    <a class="link no-decoration">
      <i *ngIf="task.notes === ''" class="icon-Add me-2"></i><i *ngIf="task.notes !== ''" class="icon-Notes icon"></i>
    </a>
  </td>-->
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No Tasks Found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<!-- <p-dialog
  [(visible)]="displayTaskDetailModal"
  (onHide)="closeTaskDetailModal()"
  class="summary-popup"
  [style]="{ width: '60%', height: '80%', maxHeight: '100%' }"
  appendTo="body"> -->
<jni-task-header-edit
  #taskHeaderEdit
  *ngIf="displayTaskDetailModal"
  [displayModal]="displayTaskDetailModal"
  [showTaskHeader]="showEditTaskModal"
  (closeAddTask)="closeTaskDetailModal($event)"
  [taskIdSelected]="taskIdSelected"
  [actionType]="'Edit'"
  (showContact)="showContactDialog($event)">
</jni-task-header-edit>
<!-- </p-dialog> -->

<!-- <jni-task-sidebar [display]="displaySidebar" (hideEvent)="hideSideBar()"></jni-task-sidebar> -->
<p-dialog
  [(visible)]="showNotesModal"
  [style]="{ width: '30%', height: '50%' }"
  appendTo="body">
  <div class="col-lg-12" *ngIf="showNotesModal">
    <div class="has-border2 pb-2 mb-4">
      <h1>Add Notes</h1>
    </div>
    <div class="col-12 mb-4">
      <div class="form-group has-float-label">
        <div class="col-lg-12 mb-4">
          <textarea
            jniAutoCompleteBlocker
            name="Notes"
            type="text"
            class="form-control"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="notes"></textarea>
        </div>
      </div>
    </div>
    <div class="col-lg-12 mt-3 d-flex gap-3 justify-content-end">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-secondary p-button-sm p-button-outlined"
        (click)="showNotesModal = false"></button>
      <button
        pButton
        type="button"
        label="Add Note"
        class="p-button-sm"
        (click)="submitNotes()"></button>
    </div>
  </div>
</p-dialog>

<jni-modal-stacker
  *ngIf="displayProdWorkflowSummary"
  [displayModal]="displayProdWorkflowSummary"
  (closeEvent)="closeWorkflowModal()">
  <div class="panelBody">
    <jni-production-workflow-summary
      *ngIf="workflowId !== 0 && displayProdWorkflowSummary"
      [salesOrderId]="salesOrderId"
      [fromOrderSummary]="true"
      (closeModalEvent)="closeWorkflowModal()"
      [workflowId]="workflowId">
    </jni-production-workflow-summary>
  </div>
</jni-modal-stacker>

<jni-confirm-dialog
  [dialogMessage]="changeAlertMessage"
  dialogHeading="Are you sure?"
  *ngIf="changeAlertVisible"
  [hideIcon]="true"
  (confirmDialogStatus)="confirmAlertBuyer($event)">
</jni-confirm-dialog>
<jni-confirm-change
  *ngIf="changeBuyerVisible"
  (confirmDialogStatus)="confirmChangeBuyer($event)">
</jni-confirm-change>
<jni-confirm-dialog
  [dialogMessage]="archiveMessage"
  dialogHeading="Are you sure?"
  *ngIf="archiveAlertVisible"
  [hideIcon]="true"
  (confirmDialogStatus)="confirmArchive($event)">
</jni-confirm-dialog>

<p-popover
  #avatarUserPopover
  appendTo="body"
  (onShow)="keepPopoverOpen()"
  (onHide)="onAvatarLeave()"
  styleClass="avatar-popover-card">
  <jni-user-avatar-details
    #userAvatarDetailsComp
    *ngIf="showUserAvatarDetails"
    [userAvatorDetails]="userAvatorDetails"
    [isLoading]="isLoading"
    (mouseenter)="keepPopoverOpen()"
    (mouseleave)="hideAvatarPopover()"
    class="ratings-box overall">
  </jni-user-avatar-details>
</p-popover>

<jni-add-contact-information
  #contactForm
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [headingStatus]="true"
  [isFromOrdersAddNewBuyer]="true"
  [addClientContact]="addClientContact"
  [customerAccountNumber]="clientId"
  (populateContactAddedInfo)="populateContactAddedInfo($event)">
</jni-add-contact-information>
